// Translation files for all supported languages

const translations = {  
  // English
  en: {
    nav: {
      home: 'HOME',
      aboutUs: 'ABOUT US',
      immigrationServices: 'eSERVICES',
      eServices: 'TOURIST INFO',
      serviceFee: 'SERVICE FEES',
      publicNotice: 'PUBLIC NOTICE',
      eLibrary: 'eLIBRARY',
      contactUs: 'CONTACT US'
    },
    quickMenu: {
      label: 'Quick Menu:',
      hotNews: 'Hot News',
      visa: 'Visa',
      passport: 'Passport',
      faqs: 'FAQs',
      // apiPnr: 'API-PNR'
    },

    home: {
      welcomeTitle: 'Welcome to Tanzania Immigration Services',
      getStarted: 'GET STARTED',
      getServiceInfo: 'WHO ARE WE',
      servicesTitle: 'Tanzania e-Immigration Online Portals',
      hotNewsTitle: 'Hot News',
      viewAll: 'View All',
      noSlidesTitle: 'No Slides Available',
      noSlidesMessage: 'There are currently no published slides to display. Please check back later.',
      whoAreWeTitle: 'Who Are We',
      readMore: 'Read More',
      commissionerGeneral: 'Commissioner General of Immigration (CGI)',
      backHome: 'Back Home',
      viewOurServices: 'View Our Services',
      otherInformation: 'Other Information'
    },

    services: {
      title: 'Our Services',
      applyNow: 'Apply Now',
      learnMore: 'Learn More',
      ourServices: 'Our Services',
      serviceFees: 'Service Fees'
    },

    eServices: {
      title: 'e-Immigration Services',
      subtitle: 'Access our online immigration services',
      description: 'Apply for various immigration services online through our secure portals'
    },

    aboutUs: {
      title: 'About Us',
      missionVision: 'Mission & Vision',
      mission: 'Mission',
      vision: 'Vision',
      motto: 'Motto',
      coreValues: 'Core Values',
      functions: 'Functions',
      organizationStructure: 'Organization Structure'
    },

    contactUs: {
      title: 'Contact Us',
      getInTouch: 'Get In Touch',
      sendMessage: 'Send Message',
      haveQuestion: 'Have a Question?',
      hereToHelp: 'We are here to help! Click the button below to send us a message',
      sendUsMessage: 'Send us Message',
      workingHours: 'Working Hours',
      mondayFriday: 'Monday - Friday: 8:00 AM - 4:00 PM',
      mondayFridayShort: 'Monday - Friday',
      workingHoursTime: '08:00 AM - 03:30 PM',
      eat: 'EAT',
      name: 'Name',
      email: 'Email',
      subject: 'Subject',
      message: 'Message',
      submit: 'Submit',
      officeHours: 'Office Hours',
      saturday: 'Saturday: Closed',
      sunday: 'Sunday: Closed'
    },

    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      close: 'Close',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      search: 'Search',
      filter: 'Filter',
      next: 'Next',
      previous: 'Previous'
    },

    footer: {
      dodoma: 'DODOMA OFFICE',
      zanzibar: 'ZANZIBAR OFFICE',
      importantLinks: 'IMPORTANT LINKS',
      copyright: 'Copyright © 2026 Tanzania Immigration Services Department. All Rights Reserved. Designed by Immigration ICT Developers.'
    },
    publicNotice: {
      title: 'Public Notice',
      hotNews: 'Hot News',
      dailyNews: 'Daily News',
      announcements: 'Announcements',
      recentNews: 'Recent News',
      videos: 'Videos',
      gallery: 'Gallery',
      download: 'Download',
      viewMore: 'View More',
      prev: 'Prev',
      next: 'Next',
      noNews: 'No news available',
      noAnnouncements: 'No announcements available',
      noVideos: 'No videos available',
      watchVideo: 'Watch Video',
      closeVideo: 'Close Video'
    },

    downloads: {
      title: 'Downloads',
      searchPlaceholder: 'Search documents...',
      sortBy: 'Sort By',
      newest: 'Newest',
      oldest: 'Oldest',
      nameAZ: 'Name A-Z',
      nameZA: 'Name Z-A',
      download: 'Download',
      noDocuments: 'No documents found',
      fileSize: 'File Size',
      uploadDate: 'Upload Date'
    },

    eLibrary: {
      title: 'e-Library',
      searchPlaceholder: 'Search library...',
      categories: 'Categories',
      allCategories: 'All Categories',
      documents: 'Documents',
      publications: 'Publications',
      reports: 'Reports',
      guidelines: 'Guidelines',
      noResults: 'No results found'
    },

    immigrationServices: {
      title: 'Immigration Services',
      permits: 'Permits',
      visas: 'Visas',
      citizenship: 'Citizenship',
      passport: 'Passport',
      travelDocument: 'Travel Document',
      requirements: 'Requirements',
      howToApply: 'How to Apply',
      processingTime: 'Processing Time',
      fees: 'Fees',
      applyOnline: 'Apply Online',
      downloadForm: 'Download Form'
    },

    serviceFee: {
      title: 'Service Fees',
      serviceType: 'Service Type',
      fee: 'Fee',
      currency: 'Currency',
      processingTime: 'Processing Time',
      notes: 'Notes',
      searchFees: 'Search fees...',
      allServices: 'All Services'
    },

    faq: {
      title: 'Frequently Asked Questions',
      searchPlaceholder: 'Search questions...',
      noResults: 'No questions found',
      categories: 'Categories',
      allQuestions: 'All Questions'
    },

    forms: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email Address',
      phone: 'Phone Number',
      message: 'Your Message',
      submit: 'Submit',
      sending: 'Sending...',
      required: 'Required',
      invalidEmail: 'Invalid email address',
      messageSent: 'Message sent successfully',
      messageError: 'Failed to send message'
    },

    pagination: {
      page: 'Page',
      of: 'of',
      showing: 'Showing',
      entries: 'entries',
      first: 'First',
      last: 'Last',
      next: 'Next',
      previous: 'Previous'
    }
  },

  // Swahili (Default)
  sw: {
    nav: {
      home: 'NYUMBANI',
      aboutUs: 'KUHUSU SISI',
      immigrationServices: 'HUDUMA ZA UHAMIAJI',
      eServices: 'HUDUMA ZA MTANDAO',
      serviceFee: 'ADA ZA HUDUMA',
      publicNotice: 'TANGAZO LA UMMA',
      eLibrary: 'MAKTABA YA MTANDAO',
      contactUs: 'WASILIANA NASI'
    },

    quickMenu: {
      label: 'Menyu ya Haraka:',
      hotNews: 'Habari Muhimu',
      visa: 'Visa',
      passport: 'Pasipoti',
      faqs: 'Maswali Yanayoulizwa Mara kwa Mara'
    },

    home: {
      welcomeTitle: 'Karibu Idara ya Uhamiaji Tanzania',
      getStarted: 'ANZA SASA',
      getServiceInfo: 'Taarifa za Huduma',
      servicesTitle: 'Huduma za Uhamiaji za Mtandao Tanzania',
      hotNewsTitle: 'Habari Muhimu',
      viewAll: 'Tazama Zote',
      noSlidesTitle: 'Hakuna Slaidi Zinazopatikana',
      noSlidesMessage: 'Kwa sasa hakuna slaidi zilizochapishwa za kuonyesha. Tafadhali angalia baadaye.',
      whoAreWeTitle: 'Sisi Ni Nani',
      readMore: 'Soma Zaidi',
      commissionerGeneral: 'Kamishna Jenerali wa Uhamiaji (CGI)',
      backHome: 'Rudi Nyumbani',
      viewOurServices: 'Tazama Huduma Zetu',
      otherInformation: 'Taarifa Nyingine'
    },

    services: {
      title: 'Huduma Zetu',
      applyNow: 'Omba Sasa',
      learnMore: 'Jifunze Zaidi',
      ourServices: 'Huduma Zetu',
      serviceFees: 'Ada za Huduma'
    },

    eServices: {
      title: 'Huduma za Uhamiaji za Mtandao',
      subtitle: 'Pata huduma zetu za uhamiaji za mtandaoni',
      description: 'Omba huduma mbalimbali za uhamiaji mtandaoni kupitia majukwaa yetu salama'
    },

    aboutUs: {
      title: 'Kuhusu Sisi',
      missionVision: 'Dhamira na Dira',
      mission: 'Dhamira',
      vision: 'Dira',
      motto: 'Kauli Mbiu',
      coreValues: 'Maadili Muhimu',
      functions: 'Majukumu',
      organizationStructure: 'Muundo wa Shirika'
    },

    contactUs: {
      title: 'Wasiliana Nasi',
      getInTouch: 'Wasiliana',
      sendMessage: 'Tuma Ujumbe',
      haveQuestion: 'Una Swali?',
      hereToHelp: 'Tuko hapa kukusaidia! Bofya kitufe hapa chini kututumia ujumbe',
      sendUsMessage: 'Tutumia Ujumbe',
      workingHours: 'Saa za Kazi',
      mondayFriday: 'Jumatatu - Ijumaa: 8:00 Asubuhi - 4:00 Jioni',
      mondayFridayShort: 'Jumatatu - Ijumaa',
      workingHoursTime: '08:00 Asubuhi - 03:30 Jioni',
      eat: 'EAT',
      name: 'Jina',
      email: 'Barua Pepe',
      subject: 'Mada',
      message: 'Ujumbe',
      submit: 'Wasilisha',
      officeHours: 'Saa za Ofisi',
      saturday: 'Jumamosi: Imefungwa',
      sunday: 'Jumapili: Imefungwa'
    },

    common: {
      loading: 'Inapakia...',
      error: 'Kosa',
      success: 'Imefanikiwa',
      close: 'Funga',
      cancel: 'Ghairi',
      save: 'Hifadhi',
      delete: 'Futa',
      edit: 'Hariri',
      search: 'Tafuta',
      filter: 'Chuja',
      next: 'Ifuatayo',
      previous: 'Iliyopita'
    },

    footer: {
      dodoma: 'OFISI YA DODOMA',
      zanzibar: 'OFISI YA ZANZIBAR',
      importantLinks: 'VIUNGO MUHIMU',
      copyright: 'Hakimiliki © 2026 Idara ya Uhamiaji Tanzania. Haki Zote Zimehifadhiwa. Imeundwa na Watengenezaji wa ICT wa Uhamiaji.'
    },

    publicNotice: {
      title: 'Tangazo la Umma',
      hotNews: 'Habari za Moto',
      dailyNews: 'Habari za Kila Siku',
      announcements: 'Matangazo',
      recentNews: 'Habari za Hivi Karibuni',
      videos: 'Video',
      gallery: 'Picha',
      download: 'Pakua',
      viewMore: 'Tazama Zaidi',
      prev: 'Iliyotangulia',
      next: 'Inayofuata',
      noNews: 'Hakuna habari zinazopatikana',
      noAnnouncements: 'Hakuna matangazo yanapatikana',
      noVideos: 'Hakuna video zinazopatikana',
      watchVideo: 'Tazama Video',
      closeVideo: 'Funga Video'
    },

    downloads: {
      title: 'Vipakuliwa',
      searchPlaceholder: 'Tafuta nyaraka...',
      sortBy: 'Panga Kwa',
      newest: 'Mpya Zaidi',
      oldest: 'Zamani Zaidi',
      nameAZ: 'Jina A-Z',
      nameZA: 'Jina Z-A',
      download: 'Pakua',
      noDocuments: 'Hakuna nyaraka zilizopatikana',
      fileSize: 'Ukubwa wa Faili',
      uploadDate: 'Tarehe ya Kupakia'
    },

    eLibrary: {
      title: 'Maktaba ya Mtandao',
      searchPlaceholder: 'Tafuta maktaba...',
      categories: 'Makundi',
      allCategories: 'Makundi Yote',
      documents: 'Nyaraka',
      publications: 'Machapisho',
      reports: 'Ripoti',
      guidelines: 'Miongozo',
      noResults: 'Hakuna matokeo yaliyopatikana'
    },

    immigrationServices: {
      title: 'Huduma za Uhamiaji',
      permits: 'Vibali',
      visas: 'Visa',
      citizenship: 'Uraia',
      passport: 'Pasipoti',
      travelDocument: 'Hati ya Kusafiria',
      requirements: 'Mahitaji',
      howToApply: 'Jinsi ya Kuomba',
      processingTime: 'Muda wa Uchakataji',
      fees: 'Ada',
      applyOnline: 'Omba Mtandaoni',
      downloadForm: 'Pakua Fomu'
    },

    serviceFee: {
      title: 'Ada za Huduma',
      serviceType: 'Aina ya Huduma',
      fee: 'Ada',
      currency: 'Sarafu',
      processingTime: 'Muda wa Uchakataji',
      notes: 'Maelezo',
      searchFees: 'Tafuta ada...',
      allServices: 'Huduma Zote'
    },

    faq: {
      title: 'Maswali Yanayoulizwa Mara kwa Mara',
      searchPlaceholder: 'Tafuta maswali...',
      noResults: 'Hakuna maswali yaliyopatikana',
      categories: 'Makundi',
      allQuestions: 'Maswali Yote'
    },

    forms: {
      firstName: 'Jina la Kwanza',
      lastName: 'Jina la Mwisho',
      email: 'Anwani ya Barua Pepe',
      phone: 'Nambari ya Simu',
      message: 'Ujumbe Wako',
      submit: 'Wasilisha',
      sending: 'Inatuma...',
      required: 'Inahitajika',
      invalidEmail: 'Anwani ya barua pepe si sahihi',
      messageSent: 'Ujumbe umetumwa kwa mafanikio',
      messageError: 'Imeshindwa kutuma ujumbe'
    },

    pagination: {
      page: 'Ukurasa',
      of: 'ya',
      showing: 'Inaonyesha',
      entries: 'maingizo',
      first: 'Kwanza',
      last: 'Mwisho',
      next: 'Ifuatayo',
      previous: 'Iliyopita'
    }
  },



  // Chinese
  zh: {
    nav: {
      home: '主页',
      aboutUs: '关于我们',
      immigrationServices: '移民服务',
      eServices: '电子服务',
      serviceFee: '服务费',
      publicNotice: '公告',
      eLibrary: '电子图书馆',
      contactUs: '联系我们'
    },

    quickMenu: {
      label: '快速菜单：',
      hotNews: '热点新闻',
      visaGuidelines: '签证指南',
      faqs: '常见问题'
    },

    home: {
      welcomeTitle: '欢迎来到坦桑尼亚移民服务',
      getStarted: '开始',
      getServiceInfo: '服务信息',
      servicesTitle: '坦桑尼亚电子移民在线门户',
      hotNewsTitle: '热点新闻',
      viewAll: '查看全部',
      noSlidesTitle: '没有可用的幻灯片',
      noSlidesMessage: '目前没有已发布的幻灯片可显示。请稍后再查看。',
      whoAreWeTitle: '我们是谁',
      readMore: '阅读更多',
      commissionerGeneral: '移民总专员 (CGI)',
      backHome: '返回主页',
      viewOurServices: '查看我们的服务',
      otherInformation: '其他信息'
    },

    services: {
      title: '我们的服务',
      applyNow: '立即申请',
      learnMore: '了解更多',
      ourServices: '我们的服务',
      serviceFees: '服务费'
    },

    eServices: {
      title: '电子移民服务',
      subtitle: '访问我们的在线移民服务',
      description: '通过我们的安全门户在线申请各种移民服务'
    },

    aboutUs: {
      title: '关于我们',
      missionVision: '使命与愿景',
      mission: '使命',
      vision: '愿景',
      motto: '座右铭',
      coreValues: '核心价值观',
      functions: '职能',
      organizationStructure: '组织结构'
    },

    contactUs: {
      title: '联系我们',
      getInTouch: '取得联系',
      sendMessage: '发送消息',
      haveQuestion: '有问题吗？',
      hereToHelp: '我们在这里为您提供帮助！点击下方按钮给我们发送消息',
      sendUsMessage: '给我们发消息',
      workingHours: '工作时间',
      mondayFriday: '周一至周五：上午8:00 - 下午4:00',
      mondayFridayShort: '周一至周五',
      workingHoursTime: '上午08:00 - 下午03:30',
      eat: 'EAT',
      name: '姓名',
      email: '电子邮件',
      subject: '主题',
      message: '消息',
      submit: '提交',
      officeHours: '办公时间',
      saturday: '周六：关闭',
      sunday: '周日：关闭'
    },

    common: {
      loading: '加载中...',
      error: '错误',
      success: '成功',
      close: '关闭',
      cancel: '取消',
      save: '保存',
      delete: '删除',
      edit: '编辑',
      search: '搜索',
      filter: '筛选',
      next: '下一个',
      previous: '上一个'
    },

    footer: {
      dodoma: '多多马办事处',
      zanzibar: '桑给巴尔办事处',
      importantLinks: '重要链接',
      copyright: '版权所有 © 2026 坦桑尼亚移民局。保留所有权利。由移民ICT开发人员设计。'
    },

    publicNotice: {
      title: '公告',
      hotNews: '热点新闻',
      dailyNews: '每日新闻',
      announcements: '公告',
      recentNews: '最新消息',
      videos: '视频',
      gallery: '图库',
      download: '下载',
      viewMore: '查看更多',
      prev: '上一页',
      next: '下一页',
      noNews: '暂无新闻',
      noAnnouncements: '暂无公告',
      noVideos: '暂无视频',
      watchVideo: '观看视频',
      closeVideo: '关闭视频'
    },

    downloads: {
      title: '下载',
      searchPlaceholder: '搜索文档...',
      sortBy: '排序方式',
      newest: '最新',
      oldest: '最旧',
      nameAZ: '名称 A-Z',
      nameZA: '名称 Z-A',
      download: '下载',
      noDocuments: '未找到文档',
      fileSize: '文件大小',
      uploadDate: '上传日期'
    },

    eLibrary: {
      title: '电子图书馆',
      searchPlaceholder: '搜索图书馆...',
      categories: '分类',
      allCategories: '所有分类',
      documents: '文档',
      publications: '出版物',
      reports: '报告',
      guidelines: '指南',
      noResults: '未找到结果'
    },

    immigrationServices: {
      title: '移民服务',
      permits: '许可证',
      visas: '签证',
      citizenship: '公民身份',
      passport: '护照',
      travelDocument: '旅行证件',
      requirements: '要求',
      howToApply: '如何申请',
      processingTime: '处理时间',
      fees: '费用',
      applyOnline: '在线申请',
      downloadForm: '下载表格'
    },

    serviceFee: {
      title: '服务费',
      serviceType: '服务类型',
      fee: '费用',
      currency: '货币',
      processingTime: '处理时间',
      notes: '备注',
      searchFees: '搜索费用...',
      allServices: '所有服务'
    },

    faq: {
      title: '常见问题',
      searchPlaceholder: '搜索问题...',
      noResults: '未找到问题',
      categories: '分类',
      allQuestions: '所有问题'
    },

    forms: {
      firstName: '名',
      lastName: '姓',
      email: '电子邮件地址',
      phone: '电话号码',
      message: '您的留言',
      submit: '提交',
      sending: '发送中...',
      required: '必填',
      invalidEmail: '无效的电子邮件地址',
      messageSent: '消息发送成功',
      messageError: '发送消息失败'
    },

    pagination: {
      page: '页',
      of: '共',
      showing: '显示',
      entries: '条目',
      first: '首页',
      last: '末页',
      next: '下一页',
      previous: '上一页'
    }
  },

  // French
  fr: {
    nav: {
      home: 'ACCUEIL',
      aboutUs: 'À PROPOS',
      immigrationServices: 'SERVICES D\'IMMIGRATION',
      eServices: 'SERVICES EN LIGNE',
      serviceFee: 'FRAIS DE SERVICE',
      publicNotice: 'AVIS PUBLIC',
      eLibrary: 'BIBLIOTHÈQUE EN LIGNE',
      contactUs: 'CONTACTEZ-NOUS'
    },

    quickMenu: {
      label: 'Menu Rapide:',
      hotNews: 'Actualités',
      visaGuidelines: 'Directives VISA',
      faqs: 'FAQ'
    },

    home: {
      welcomeTitle: 'Bienvenue aux Services d\'Immigration de Tanzanie',
      getStarted: 'COMMENCER',
      getServiceInfo: 'Info. Services',
      servicesTitle: 'Portails en ligne d\'e-Immigration de Tanzanie',
      hotNewsTitle: 'Actualités',
      viewAll: 'Voir Tout',
      noSlidesTitle: 'Aucune Diapositive Disponible',
      noSlidesMessage: 'Il n\'y a actuellement aucune diapositive publiée à afficher. Veuillez revenir plus tard.',
      whoAreWeTitle: 'Qui Sommes-Nous',
      readMore: 'Lire Plus',
      commissionerGeneral: 'Commissaire Général de l\'Immigration (CGI)',
      backHome: 'Retour à l\'Accueil',
      viewOurServices: 'Voir Nos Services',
      otherInformation: 'Autres Informations'
    },

    services: {
      title: 'Nos Services',
      applyNow: 'Postuler Maintenant',
      learnMore: 'En Savoir Plus',
      ourServices: 'Nos Services',
      serviceFees: 'Frais de Service'
    },

    eServices: {
      title: 'Services d\'e-Immigration',
      subtitle: 'Accédez à nos services d\'immigration en ligne',
      description: 'Demandez divers services d\'immigration en ligne via nos portails sécurisés'
    },
 
    aboutUs: {
      title: 'À Propos',
      missionVision: 'Mission et Vision',
      mission: 'Mission',
      vision: 'Vision',
      motto: 'Devise',
      coreValues: 'Valeurs Fondamentales',
      functions: 'Fonctions',
      organizationStructure: 'Structure Organisationnelle'
    },

    contactUs: {
      title: 'Contactez-Nous',
      getInTouch: 'Entrer en Contact',
      sendMessage: 'Envoyer un Message',
      haveQuestion: 'Vous avez une question ?',
      hereToHelp: 'Nous sommes là pour vous aider ! Cliquez sur le bouton ci-dessous pour nous envoyer un message',
      sendUsMessage: 'Envoyez-nous un Message',
      workingHours: 'Heures de Travail',
      mondayFriday: 'Lundi - Vendredi: 8h00 - 16h00',
      mondayFridayShort: 'Lundi - Vendredi',
      workingHoursTime: '08h00 - 15h30',
      eat: 'EAT',
      name: 'Nom',
      email: 'Email',
      subject: 'Sujet',
      message: 'Message',
      submit: 'Soumettre',
      officeHours: 'Heures de Bureau',
      saturday: 'Samedi: Fermé',
      sunday: 'Dimanche: Fermé'
    },

    common: {
      loading: 'Chargement...',
      error: 'Erreur',
      success: 'Succès',
      close: 'Fermer',
      cancel: 'Annuler',
      save: 'Enregistrer',
      delete: 'Supprimer',
      edit: 'Modifier',
      search: 'Rechercher',
      filter: 'Filtrer',
      next: 'Suivant',
      previous: 'Précédent'
    },

    footer: {
      dodoma: 'BUREAU DE DODOMA',
      zanzibar: 'BUREAU DE ZANZIBAR',
      importantLinks: 'LIENS IMPORTANTS',
      copyright: 'Copyright © 2026 Département de l\'Immigration de Tanzanie. Tous droits réservés. Conçu par les développeurs ICT de l\'Immigration.'
    },

    publicNotice: {
      title: 'Avis Public',
      hotNews: 'Actualités Chaudes',
      dailyNews: 'Actualités Quotidiennes',
      announcements: 'Annonces',
      recentNews: 'Actualités Récentes',
      videos: 'Vidéos',
      gallery: 'Galerie',
      download: 'Télécharger',
      viewMore: 'Voir Plus',
      prev: 'Précédent',
      next: 'Suivant',
      noNews: 'Aucune actualité disponible',
      noAnnouncements: 'Aucune annonce disponible',
      noVideos: 'Aucune vidéo disponible',
      watchVideo: 'Regarder la Vidéo',
      closeVideo: 'Fermer la Vidéo'
    },

    downloads: {
      title: 'Téléchargements',
      searchPlaceholder: 'Rechercher des documents...',
      sortBy: 'Trier Par',
      newest: 'Plus Récent',
      oldest: 'Plus Ancien',
      nameAZ: 'Nom A-Z',
      nameZA: 'Nom Z-A',
      download: 'Télécharger',
      noDocuments: 'Aucun document trouvé',
      fileSize: 'Taille du Fichier',
      uploadDate: 'Date de Téléchargement'
    },

    eLibrary: {
      title: 'Bibliothèque en Ligne',
      searchPlaceholder: 'Rechercher dans la bibliothèque...',
      categories: 'Catégories',
      allCategories: 'Toutes les Catégories',
      documents: 'Documents',
      publications: 'Publications',
      reports: 'Rapports',
      guidelines: 'Directives',
      noResults: 'Aucun résultat trouvé'
    },

    immigrationServices: {
      title: 'Services d\'Immigration',
      permits: 'Permis',
      visas: 'Visas',
      citizenship: 'Citoyenneté',
      passport: 'Passeport',
      travelDocument: 'Document de Voyage',
      requirements: 'Exigences',
      howToApply: 'Comment Postuler',
      processingTime: 'Délai de Traitement',
      fees: 'Frais',
      applyOnline: 'Postuler en Ligne',
      downloadForm: 'Télécharger le Formulaire'
    },

    serviceFee: {
      title: 'Frais de Service',
      serviceType: 'Type de Service',
      fee: 'Frais',
      currency: 'Devise',
      processingTime: 'Délai de Traitement',
      notes: 'Notes',
      searchFees: 'Rechercher les frais...',
      allServices: 'Tous les Services'
    },

    faq: {
      title: 'Questions Fréquemment Posées',
      searchPlaceholder: 'Rechercher des questions...',
      noResults: 'Aucune question trouvée',
      categories: 'Catégories',
      allQuestions: 'Toutes les Questions'
    },

    forms: {
      firstName: 'Prénom',
      lastName: 'Nom de Famille',
      email: 'Adresse Email',
      phone: 'Numéro de Téléphone',
      message: 'Votre Message',
      submit: 'Soumettre',
      sending: 'Envoi en cours...',
      required: 'Requis',
      invalidEmail: 'Adresse email invalide',
      messageSent: 'Message envoyé avec succès',
      messageError: 'Échec de l\'envoi du message'
    },

    pagination: {
      page: 'Page',
      of: 'sur',
      showing: 'Affichage',
      entries: 'entrées',
      first: 'Premier',
      last: 'Dernier',
      next: 'Suivant',
      previous: 'Précédent'
    }
  },

  // Hindi
  hi: {
    nav: {
      home: 'मुख्य पृष्ठ',
      aboutUs: 'हमारे बारे में',
      immigrationServices: 'आप्रवासन सेवाएं',
      eServices: 'ई-सेवाएं',
      serviceFee: 'सेवा शुल्क',
      publicNotice: 'सार्वजनिक सूचना',
      eLibrary: 'ई-पुस्तकालय',
      contactUs: 'संपर्क करें'
    },

    quickMenu: {
      label: 'त्वरित मेनू:',
      hotNews: 'महत्वपूर्ण समाचार',
      visaGuidelines: 'वीज़ा दिशानिर्देश',
      faqs: 'अक्सर पूछे जाने वाले प्रश्न'
    },

    home: {
      welcomeTitle: 'तंजानिया आप्रवासन सेवाओं में आपका स्वागत है',
      getStarted: 'शुरू करें',
      getServiceInfo: 'सेवा जानकारी',
      servicesTitle: 'तंजानिया ई-आप्रवासन ऑनलाइन पोर्टल',
      hotNewsTitle: 'महत्वपूर्ण समाचार',
      viewAll: 'सभी देखें',
      noSlidesTitle: 'कोई स्लाइड उपलब्ध नहीं',
      noSlidesMessage: 'वर्तमान में प्रदर्शित करने के लिए कोई प्रकाशित स्लाइड नहीं हैं। कृपया बाद में जांचें।',
      whoAreWeTitle: 'हम कौन हैं',
      readMore: 'और पढ़ें',
      commissionerGeneral: 'आप्रवासन के आयुक्त जनरल (CGI)',
      backHome: 'घर वापस जाएं',
      viewOurServices: 'हमारी सेवाएं देखें',
      otherInformation: 'अन्य जानकारी'
    },

    services: {
      title: 'हमारी सेवाएं',
      applyNow: 'अभी आवेदन करें',
      learnMore: 'और जानें',
      ourServices: 'हमारी सेवाएं',
      serviceFees: 'सेवा शुल्क'
    },

    eServices: {
      title: 'ई-आप्रवासन सेवाएं',
      subtitle: 'हमारी ऑनलाइन आप्रवासन सेवाओं तक पहुंचें',
      description: 'हमारे सुरक्षित पोर्टल के माध्यम से विभिन्न आप्रवासन सेवाओं के लिए ऑनलाइन आवेदन करें'
    },

    aboutUs: {
      title: 'हमारे बारे में',
      missionVision: 'मिशन और विजन',
      mission: 'मिशन',
      vision: 'विजन',
      motto: 'आदर्श वाक्य',
      coreValues: 'मूल मूल्य',
      functions: 'कार्य',
      organizationStructure: 'संगठनात्मक संरचना'
    },

    contactUs: {
      title: 'संपर्क करें',
      getInTouch: 'संपर्क में रहें',
      sendMessage: 'संदेश भेजें',
      haveQuestion: 'कोई सवाल है?',
      hereToHelp: 'हम यहाँ मदद के लिए हैं! नीचे दिए गए बटन पर क्लिक करके हमें संदेश भेजें',
      sendUsMessage: 'हमें संदेश भेजें',
      workingHours: 'कार्य समय',
      mondayFriday: 'सोमवार - शुक्रवार: सुबह 8:00 - शाम 4:00',
      mondayFridayShort: 'सोमवार - शुक्रवार',
      workingHoursTime: 'सुबह 08:00 - दोपहर 03:30',
      eat: 'EAT',
      name: 'नाम',
      email: 'ईमेल',
      subject: 'विषय',
      message: 'संदेश',
      submit: 'जमा करें',
      officeHours: 'कार्यालय समय',
      saturday: 'शनिवार: बंद',
      sunday: 'रविवार: बंद'
    },

    common: {
      loading: 'लोड हो रहा है...',
      error: 'त्रुटि',
      success: 'सफलता',
      close: 'बंद करें',
      cancel: 'रद्द करें',
      save: 'सहेजें',
      delete: 'हटाएं',
      edit: 'संपादित करें',
      search: 'खोजें',
      filter: 'फ़िल्टर',
      next: 'अगला',
      previous: 'पिछला'
    },

    footer: {
      dodoma: 'डोडोमा कार्यालय',
      zanzibar: 'ज़ांज़ीबार कार्यालय',
      importantLinks: 'महत्वपूर्ण लिंक',
      copyright: 'कॉपीराइट © 2026 तंजानिया आप्रवासन विभाग। सर्वाधिकार सुरक्षित। आप्रवासन आईसीटी डेवलपर्स द्वारा डिज़ाइन किया गया।'
    },

    publicNotice: {
      title: 'सार्वजनिक सूचना',
      hotNews: 'ताज़ा खबरें',
      dailyNews: 'दैनिक समाचार',
      announcements: 'घोषणाएं',
      recentNews: 'हाल की खबरें',
      videos: 'वीडियो',
      gallery: 'गैलरी',
      download: 'डाउनलोड',
      viewMore: 'और देखें',
      prev: 'पिछला',
      next: 'अगला',
      noNews: 'कोई समाचार उपलब्ध नहीं',
      noAnnouncements: 'कोई घोषणा उपलब्ध नहीं',
      noVideos: 'कोई वीडियो उपलब्ध नहीं',
      watchVideo: 'वीडियो देखें',
      closeVideo: 'वीडियो बंद करें'
    },

    downloads: {
      title: 'डाउनलोड',
      searchPlaceholder: 'दस्तावेज़ खोजें...',
      sortBy: 'इसके अनुसार क्रमबद्ध करें',
      newest: 'नवीनतम',
      oldest: 'सबसे पुराना',
      nameAZ: 'नाम A-Z',
      nameZA: 'नाम Z-A',
      download: 'डाउनलोड',
      noDocuments: 'कोई दस्तावेज़ नहीं मिला',
      fileSize: 'फ़ाइल का आकार',
      uploadDate: 'अपलोड तिथि'
    },

    eLibrary: {
      title: 'ई-पुस्तकालय',
      searchPlaceholder: 'पुस्तकालय खोजें...',
      categories: 'श्रेणियां',
      allCategories: 'सभी श्रेणियां',
      documents: 'दस्तावेज़',
      publications: 'प्रकाशन',
      reports: 'रिपोर्ट',
      guidelines: 'दिशानिर्देश',
      noResults: 'कोई परिणाम नहीं मिला'
    },

    immigrationServices: {
      title: 'आप्रवासन सेवाएं',
      permits: 'परमिट',
      visas: 'वीज़ा',
      citizenship: 'नागरिकता',
      passport: 'पासपोर्ट',
      travelDocument: 'यात्रा दस्तावेज़',
      requirements: 'आवश्यकताएं',
      howToApply: 'आवेदन कैसे करें',
      processingTime: 'प्रसंस्करण समय',
      fees: 'शुल्क',
      applyOnline: 'ऑनलाइन आवेदन करें',
      downloadForm: 'फॉर्म डाउनलोड करें'
    },

    serviceFee: {
      title: 'सेवा शुल्क',
      serviceType: 'सेवा प्रकार',
      fee: 'शुल्क',
      currency: 'मुद्रा',
      processingTime: 'प्रसंस्करण समय',
      notes: 'नोट्स',
      searchFees: 'शुल्क खोजें...',
      allServices: 'सभी सेवाएं'
    },

    faq: {
      title: 'अक्सर पूछे जाने वाले प्रश्न',
      searchPlaceholder: 'प्रश्न खोजें...',
      noResults: 'कोई प्रश्न नहीं मिला',
      categories: 'श्रेणियां',
      allQuestions: 'सभी प्रश्न'
    },

    forms: {
      firstName: 'पहला नाम',
      lastName: 'अंतिम नाम',
      email: 'ईमेल पता',
      phone: 'फ़ोन नंबर',
      message: 'आपका संदेश',
      submit: 'जमा करें',
      sending: 'भेजा जा रहा है...',
      required: 'आवश्यक',
      invalidEmail: 'अमान्य ईमेल पता',
      messageSent: 'संदेश सफलतापूर्वक भेजा गया',
      messageError: 'संदेश भेजने में विफल'
    },

    pagination: {
      page: 'पृष्ठ',
      of: 'का',
      showing: 'दिखा रहा है',
      entries: 'प्रविष्टियां',
      first: 'पहला',
      last: 'अंतिम',
      next: 'अगला',
      previous: 'पिछला'
    }
  },

  // Arabic
  ar: {
    nav: {
      home: 'الرئيسية',
      aboutUs: 'معلومات عنا',
      immigrationServices: 'خدمات الهجرة',
      eServices: 'الخدمات الإلكترونية',
      serviceFee: 'رسوم الخدمة',
      publicNotice: 'إشعار عام',
      eLibrary: 'المكتبة الإلكترونية',
      contactUs: 'اتصل بنا'
    },

    quickMenu: {
      label: 'القائمة السريعة:',
      hotNews: 'أخبار ساخنة',
      visaGuidelines: 'إرشادات التأشيرة',
     faqs: 'الأسئلة الشائعة'
    },

    home: {
      welcomeTitle: 'مرحبا بكم في خدمات الهجرة تنزانيا',
      getStarted: 'ابدأ',
      getServiceInfo: 'معلومات الخدمات',
      servicesTitle: 'بوابات الهجرة الإلكترونية تنزانيا',
      hotNewsTitle: 'أخبار ساخنة',
      viewAll: 'عرض الكل',
      noSlidesTitle: 'لا توجد شرائح متاحة',
      noSlidesMessage: 'لا توجد حاليًا شرائح منشورة لعرضها. يرجى التحقق مرة أخرى لاحقًا.',
      whoAreWeTitle: 'من نحن',
      readMore: 'اقرأ المزيد',
      commissionerGeneral: 'المفوض العام للهجرة (CGI)',
      backHome: 'العودة إلى الصفحة الرئيسية',
      viewOurServices: 'عرض خدماتنا',
      otherInformation: 'معلومات أخرى'
    },

    services: {
      title: 'خدماتنا',
      applyNow: 'قدم الآن',
      learnMore: 'تعلم المزيد',
      ourServices: 'خدماتنا',
      serviceFees: 'رسوم الخدمة'
    },

    eServices: {
      title: 'خدمات الهجرة الإلكترونية',
      subtitle: 'الوصول إلى خدمات الهجرة عبر الإنترنت',
      description: 'تقدم بطلب للحصول على خدمات الهجرة المختلفة عبر الإنترنت من خلال بواباتنا الآمنة'
    },

    aboutUs: {
      title: 'معلومات عنا',
      missionVision: 'المهمة والرؤية',
      mission: 'المهمة',
      vision: 'الرؤية',
      motto: 'الشعار',
      coreValues: 'القيم الأساسية',
      functions: 'الوظائف',
      organizationStructure: 'الهيكل التنظيمي'
    },

    contactUs: {
      title: 'اتصل بنا',
      getInTouch: 'ابق على تواصل',
      sendMessage: 'إرسال رسالة',
      haveQuestion: 'هل لديك سؤال؟',
      hereToHelp: 'نحن هنا لمساعدتك! انقر على الزر أدناه لإرسال رسالة لنا',
      sendUsMessage: 'أرسل لنا رسالة',
      workingHours: 'ساعات العمل',
      mondayFriday: 'الاثنين - الجمعة: 8:00 صباحًا - 4:00 مساءً',
      mondayFridayShort: 'الاثنين - الجمعة',
      workingHoursTime: '08:00 صباحًا - 03:30 مساءً',
      eat: 'EAT',
      name: 'الاسم',
      email: 'البريد الإلكتروني',
      subject: 'الموضوع',
      message: 'الرسالة',
      submit: 'إرسال',
      officeHours: 'ساعات العمل',
      saturday: 'السبت: مغلق',
      sunday: 'الأحد: مغلق'
    },

    common: {
      loading: 'جار التحميل...',
      error: 'خطأ',
      success: 'نجاح',
      close: 'إغلاق',
      cancel: 'إلغاء',
      save: 'حفظ',
      delete: 'حذف',
      edit: 'تحرير',
      search: 'بحث',
      filter: 'تصفية',
      next: 'التالي',
      previous: 'السابق'
    },

    footer: {
      dodoma: 'مكتب دودوما',
      zanzibar: 'مكتب زنجبار',
      importantLinks: 'روابط مهمة',
      copyright: 'حقوق النشر © 2026 إدارة الهجرة تنزانيا. جميع الحقوق محفوظة. صمم من قبل مطوري تكنولوجيا المعلومات والاتصالات للهجرة.'
    },

    publicNotice: {
      title: 'إشعار عام',
      hotNews: 'أخبار عاجلة',
      dailyNews: 'الأخبار اليومية',
      announcements: 'الإعلانات',
      recentNews: 'آخر الأخبار',
      videos: 'فيديوهات',
      gallery: 'معرض الصور',
      download: 'تحميل',
      viewMore: 'عرض المزيد',
      prev: 'السابق',
      next: 'التالي',
      noNews: 'لا توجد أخبار متاحة',
      noAnnouncements: 'لا توجد إعلانات متاحة',
      noVideos: 'لا توجد فيديوهات متاحة',
      watchVideo: 'مشاهدة الفيديو',
      closeVideo: 'إغلاق الفيديو'
    },

    downloads: {
      title: 'التحميلات',
      searchPlaceholder: 'البحث في المستندات...',
      sortBy: 'ترتيب حسب',
      newest: 'الأحدث',
      oldest: 'الأقدم',
      nameAZ: 'الاسم أ-ي',
      nameZA: 'الاسم ي-أ',
      download: 'تحميل',
      noDocuments: 'لم يتم العثور على مستندات',
      fileSize: 'حجم الملف',
      uploadDate: 'تاريخ الرفع'
    },

    eLibrary: {
      title: 'المكتبة الإلكترونية',
      searchPlaceholder: 'البحث في المكتبة...',
      categories: 'الفئات',
      allCategories: 'جميع الفئات',
      documents: 'المستندات',
      publications: 'المنشورات',
      reports: 'التقارير',
      guidelines: 'الإرشادات',
      noResults: 'لم يتم العثور على نتائج'
    },

    immigrationServices: {
      title: 'خدمات الهجرة',
      permits: 'التصاريح',
      visas: 'التأشيرات',
      citizenship: 'الجنسية',
      passport: 'جواز السفر',
      travelDocument: 'وثيقة السفر',
      requirements: 'المتطلبات',
      howToApply: 'كيفية التقديم',
      processingTime: 'وقت المعالجة',
      fees: 'الرسوم',
      applyOnline: 'التقديم عبر الإنترنت',
      downloadForm: 'تحميل النموذج'
    },

    serviceFee: {
      title: 'رسوم الخدمة',
      serviceType: 'نوع الخدمة',
      fee: 'الرسوم',
      currency: 'العملة',
      processingTime: 'وقت المعالجة',
      notes: 'ملاحظات',
      searchFees: 'البحث في الرسوم...',
      allServices: 'جميع الخدمات'
    },

    faq: {
      title: 'الأسئلة الشائعة',
      searchPlaceholder: 'البحث في الأسئلة...',
      noResults: 'لم يتم العثور على أسئلة',
      categories: 'الفئات',
      allQuestions: 'جميع الأسئلة'
    },

    forms: {
      firstName: 'الاسم الأول',
      lastName: 'اسم العائلة',
      email: 'عنوان البريد الإلكتروني',
      phone: 'رقم الهاتف',
      message: 'رسالتك',
      submit: 'إرسال',
      sending: 'جاري الإرسال...',
      required: 'مطلوب',
      invalidEmail: 'عنوان بريد إلكتروني غير صالح',
      messageSent: 'تم إرسال الرسالة بنجاح',
      messageError: 'فشل إرسال الرسالة'
    },

    pagination: {
      page: 'صفحة',
      of: 'من',
      showing: 'عرض',
      entries: 'إدخالات',
      first: 'الأول',
      last: 'الأخير',
      next: 'التالي',
      previous: 'السابق'
    }
  },

  // German
  de: {
    nav: {
      home: 'STARTSEITE',
      aboutUs: 'ÜBER UNS',
      immigrationServices: 'EINWANDERUNGSDIENSTE',
      eServices: 'E-DIENSTE',
      serviceFee: 'SERVICEGEBÜHR',
      publicNotice: 'ÖFFENTLICHE BEKANNTMACHUNG',
      eLibrary: 'E-BIBLIOTHEK',
      contactUs: 'KONTAKT'
    },

    quickMenu: {
      label: 'Shnellmenü:',
      hotNews: 'Aktuelle Nchrichten',
      visaGuidelines: 'VISA-Richtlinen',
      faqs: 'Häufig gestellte Fragen'
    },

    home: {
      welcmeTitle: 'Willkommen bei den Einwanderungsdiensten Tansanias',
      getStarted: 'LOSLEGEN',
      getServiceInfo: 'Service-Info',
      servicesTitle: 'Tansania E-Immigration Online-Portale',
      hotNewsTitle: 'Aktuelle Nachrichten',
      viewAll: 'Alle Anzeigen',
      noSlidesTitle: 'Keine Folien Verfügbar',
      noSlidesMessage: 'Es sind derzeit keine veröffentlichten Folien zur Anzeige verfügbar. Bitte schauen Sie später noch einmal vorbei.',
      whoAreWeTitle: 'Wer Wir Sind',
      readMore: 'Mehr Lesen',
      commissionerGeneral: 'Generalkommissar für Einwanderung (CGI)',
      backHome: 'Zurück zur Startseite',
      viewOurServices: 'Unsere Dienstleistungen Ansehen',
      otherInformation: 'Weitere Informationen'
    },

    services: {
      title: 'Unsere Dienstleistungen',
      applyNow: 'Jetzt Bewerben',
      learnMore: 'Mehr Erfahren',
      ourServices: 'Unsere Dienstleistungen',
      serviceFees: 'Servicegebühren'
    },

    eServices: {
      title: 'E-Immigration Dienste',
      subtitle: 'Zugriff auf unsere Online-Einwanderungsdienste',
      description: 'Beantragen Sie verschiedene Einwanderungsdienste online über unsere sicheren Portale'
    },

    aboutUs: {
      title: 'Über Uns',
      missionVision: 'Mission und Vision',
      mission: 'Mission',
      vision: 'Vision',
      motto: 'Motto',
      coreValues: 'Grundwerte',
      functions: 'Funktionen',
      organizationStructure: 'Organisationsstruktur'
    },

    contactUs: {
      title: 'Kontakt',
      getInTouch: 'Kontaktieren Sie Uns',
      sendMessage: 'Nachricht Senden',
      haveQuestion: 'Haben Sie eine Frage?',
      hereToHelp: 'Wir sind hier, um Ihnen zu helfen! Klicken Sie auf die Schaltfläche unten, um uns eine Nachricht zu senden',
      sendUsMessage: 'Senden Sie uns eine Nachricht',
      workingHours: 'Arbeitszeiten',
      mondayFriday: 'Montag - Freitag: 8:00 - 16:00 Uhr',
      mondayFridayShort: 'Montag - Freitag',
      workingHoursTime: '08:00 - 15:30 Uhr',
      eat: 'EAT',
      name: 'Name',
      email: 'E-Mail',
      subject: 'Betreff',
      message: 'Nachricht',
      submit: 'Absenden',
      officeHours: 'Bürozeiten',
      saturday: 'Samstag: Geschlossen',
      sunday: 'Sonntag: Geschlossen'
    },

    common: {
      loading: 'Wird geladen...',
      error: 'Fehler',
      success: 'Erfolg',
      close: 'Schließen',
      cancel: 'Abbrechen',
      save: 'Speichern',
      delete: 'Löschen',
      edit: 'Bearbeiten',
      search: 'Suchen',
      filter: 'Filtern',
      next: 'Weiter',
      previous: 'Zurück'
    },

    footer: {
      dodoma: 'DODOMA BÜRO',
      zanzibar: 'SANSIBAR BÜRO',
      importantLinks: 'WICHTIGE LINKS',
      copyright: 'Copyright © 2026 Tansania Einwanderungsbehörde. Alle Rechte vorbehalten. Entwickelt von Immigration ICT-Entwicklern.'
    },

    publicNotice: {
      title: 'Öffentliche Bekanntmachung',
      hotNews: 'Heiße Nachrichten',
      dailyNews: 'Tägliche Nachrichten',
      announcements: 'Ankündigungen',
      recentNews: 'Aktuelle Nachrichten',
      videos: 'Videos',
      gallery: 'Galerie',
      download: 'Herunterladen',
      viewMore: 'Mehr Anzeigen',
      prev: 'Zurück',
      next: 'Weiter',
      noNews: 'Keine Nachrichten verfügbar',
      noAnnouncements: 'Keine Ankündigungen verfügbar',
      noVideos: 'Keine Videos verfügbar',
      watchVideo: 'Video Ansehen',
      closeVideo: 'Video Schließen'
    },

    downloads: {
      title: 'Downloads',
      searchPlaceholder: 'Dokumente suchen...',
      sortBy: 'Sortieren Nach',
      newest: 'Neueste',
      oldest: 'Älteste',
      nameAZ: 'Name A-Z',
      nameZA: 'Name Z-A',
      download: 'Herunterladen',
      noDocuments: 'Keine Dokumente gefunden',
      fileSize: 'Dateigröße',
      uploadDate: 'Hochladedatum'
    },

    eLibrary: {
      title: 'E-Bibliothek',
      searchPlaceholder: 'Bibliothek durchsuchen...',
      categories: 'Kategorien',
      allCategories: 'Alle Kategorien',
      documents: 'Dokumente',
      publications: 'Veröffentlichungen',
      reports: 'Berichte',
      guidelines: 'Richtlinien',
      noResults: 'Keine Ergebnisse gefunden'
    },

    immigrationServices: {
      title: 'Einwanderungsdienste',
      permits: 'Genehmigungen',
      visas: 'Visa',
      citizenship: 'Staatsbürgerschaft',
      passport: 'Reisepass',
      travelDocument: 'Reisedokument',
      requirements: 'Anforderungen',
      howToApply: 'Wie man sich bewirbt',
      processingTime: 'Bearbeitungszeit',
      fees: 'Gebühren',
      applyOnline: 'Online Bewerben',
      downloadForm: 'Formular Herunterladen'
    },

    serviceFee: {
      title: 'Servicegebühren',
      serviceType: 'Serviceart',
      fee: 'Gebühr',
      currency: 'Währung',
      processingTime: 'Bearbeitungszeit',
      notes: 'Hinweise',
      searchFees: 'Gebühren suchen...',
      allServices: 'Alle Dienste'
    },

    faq: {
      title: 'Häufig Gestellte Fragen',
      searchPlaceholder: 'Fragen suchen...',
      noResults: 'Keine Fragen gefunden',
      categories: 'Kategorien',
      allQuestions: 'Alle Fragen'
    },

    forms: {
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail-Adresse',
      phone: 'Telefonnummer',
      message: 'Ihre Nachricht',
      submit: 'Absenden',
      sending: 'Wird gesendet...',
      required: 'Erforderlich',
      invalidEmail: 'Ungültige E-Mail-Adresse',
      messageSent: 'Nachricht erfolgreich gesendet',
      messageError: 'Nachricht konnte nicht gesendet werden'
    },

    pagination: {
      page: 'Seite',
      of: 'von',
      showing: 'Anzeige',
      entries: 'Einträge',
      first: 'Erste',
      last: 'Letzte',
      next: 'Weiter',
      previous: 'Zurück'
    }
  },

  // Italian
  it: {
    nav: {
      home: 'HOME',
      aboutUs: 'CHI SIAMO',
      immigrationServices: 'SERVIZI DI IMMIGRAZIONE',
      eServices: 'SERVIZI ONLINE',
      serviceFee: 'TARIFFA DEL SERVIZIO',
      publicNotice: 'AVVISO PUBBLICO',
      eLibrary: 'BIBLIOTECA ONLINE',
      contactUs: 'CONTATTACI'
    },

    quickMenu: {
      label: 'Menu Rapido:',
      hotNews: 'Notizie Importanti',
      visaGuidelines: 'Linee guida VISA',
      faqs: 'Domande Frequenti'
    },

    home: {
      welcomeTitle: 'Benvenuti ai Servizi di Immigrazione della Tanzania',
      getStarted: 'INIZIA',
      getServiceInfo: 'Info. Servizi',
      servicesTitle: 'Portali online di e-Immigration della Tanzania',
      hotNewsTitle: 'Notizie Importanti',
      viewAll: 'Visualizza Tutto',
      noSlidesTitle: 'Nessuna Diapositiva Disponibile',
      noSlidesMessage: 'Al momento non ci sono diapositive pubblicate da visualizzare. Si prega di controllare più tardi.',
      whoAreWeTitle: 'Chi Siamo',
      readMore: 'Leggi di Più',
      commissionerGeneral: 'Commissario Generale dell\'Immigrazione (CGI)',
      backHome: 'Torna alla Home',
      viewOurServices: 'Visualizza i Nostri Servizi',
      otherInformation: 'Altre Informazioni'
    },

    services: {
      title: 'I Nostri Servizi',
      applyNow: 'Candidati Ora',
      learnMore: 'Scopri di Più',
      ourServices: 'I Nostri Servizi',
      serviceFees: 'Tariffe del Servizio'
    },

    eServices: {
      title: 'Servizi di e-Immigration',
      subtitle: 'Accedi ai nostri servizi di immigrazione online',
      description: 'Richiedi vari servizi di immigrazione online tramite i nostri portali sicuri'
    },

    aboutUs: {
      title: 'Chi Siamo',
      missionVision: 'Missione e Visione',
      mission: 'Missione',
      vision: 'Visione',
      motto: 'Motto',
      coreValues: 'Valori Fondamentali',
      functions: 'Funzioni',
      organizationStructure: 'Struttura Organizzativa'
    },

    contactUs: {
      title: 'Contattaci',
      getInTouch: 'Mettiti in Contatto',
      sendMessage: 'Invia Messaggio',
      haveQuestion: 'Hai una Domanda?',
      hereToHelp: 'Siamo qui per aiutarti! Clicca il pulsante qui sotto per inviarci un messaggio',
      sendUsMessage: 'Inviaci un Messaggio',
      workingHours: 'Orari di Lavoro',
      mondayFriday: 'Lunedì - Venerdì: 8:00 - 16:00',
      mondayFridayShort: 'Lunedì - Venerdì',
      workingHoursTime: '08:00 - 15:30',
      eat: 'EAT',
      name: 'Nome',
      email: 'Email',
      subject: 'Oggetto',
      message: 'Messaggio',
      submit: 'Invia',
      officeHours: 'Orari di Ufficio',
      saturday: 'Sabato: Chiuso',
      sunday: 'Domenica: Chiuso'
    },

    common: {
      loading: 'Caricamento...',
      error: 'Errore',
      success: 'Successo',
      close: 'Chiudi',
      cancel: 'Annulla',
      save: 'Salva',
      delete: 'Elimina',
      edit: 'Modifica',
      search: 'Cerca',
      filter: 'Filtra',
      next: 'Avanti',
      previous: 'Indietro'
    },

    footer: {
      dodoma: 'UFFICIO DI DODOMA',
      zanzibar: 'UFFICIO DI ZANZIBAR',
      importantLinks: 'LINK IMPORTANTI',
      copyright: 'Copyright © 2026 Dipartimento di Immigrazione della Tanzania. Tutti i diritti riservati. Progettato da sviluppatori ICT dell\'Immigrazione.'
    },

    publicNotice: {
      title: 'Avviso Pubblico',
      hotNews: 'Notizie di Tendenza',
      dailyNews: 'Notizie Quotidiane',
      announcements: 'Annunci',
      recentNews: 'Notizie Recenti',
      videos: 'Video',
      gallery: 'Galleria',
      download: 'Scarica',
      viewMore: 'Vedi Altro',
      prev: 'Precedente',
      next: 'Successivo',
      noNews: 'Nessuna notizia disponibile',
      noAnnouncements: 'Nessun annuncio disponibile',
      noVideos: 'Nessun video disponibile',
      watchVideo: 'Guarda Video',
      closeVideo: 'Chiudi Video'
    },

    downloads: {
      title: 'Download',
      searchPlaceholder: 'Cerca documenti...',
      sortBy: 'Ordina Per',
      newest: 'Più Recente',
      oldest: 'Più Vecchio',
      nameAZ: 'Nome A-Z',
      nameZA: 'Nome Z-A',
      download: 'Scarica',
      noDocuments: 'Nessun documento trovato',
      fileSize: 'Dimensione File',
      uploadDate: 'Data di Caricamento'
    },

    eLibrary: {
      title: 'Biblioteca Online',
      searchPlaceholder: 'Cerca nella biblioteca...',
      categories: 'Categorie',
      allCategories: 'Tutte le Categorie',
      documents: 'Documenti',
      publications: 'Pubblicazioni',
      reports: 'Rapporti',
      guidelines: 'Linee Guida',
      noResults: 'Nessun risultato trovato'
    },

    immigrationServices: {
      title: 'Servizi di Immigrazione',
      permits: 'Permessi',
      visas: 'Visti',
      citizenship: 'Cittadinanza',
      passport: 'Passaporto',
      travelDocument: 'Documento di Viaggio',
      requirements: 'Requisiti',
      howToApply: 'Come Candidarsi',
      processingTime: 'Tempo di Elaborazione',
      fees: 'Tariffe',
      applyOnline: 'Candidati Online',
      downloadForm: 'Scarica Modulo'
    },

    serviceFee: {
      title: 'Tariffe del Servizio',
      serviceType: 'Tipo di Servizio',
      fee: 'Tariffa',
      currency: 'Valuta',
      processingTime: 'Tempo di Elaborazione',
      notes: 'Note',
      searchFees: 'Cerca tariffe...',
      allServices: 'Tutti i Servizi'
    },

    faq: {
      title: 'Domande Frequenti',
      searchPlaceholder: 'Cerca domande...',
      noResults: 'Nessuna domanda trovata',
      categories: 'Categorie',
      allQuestions: 'Tutte le Domande'
    },

    forms: {
      firstName: 'Nome',
      lastName: 'Cognome',
      email: 'Indirizzo Email',
      phone: 'Numero di Telefono',
      message: 'Il Tuo Messaggio',
      submit: 'Invia',
      sending: 'Invio in corso...',
      required: 'Richiesto',
      invalidEmail: 'Indirizzo email non valido',
      messageSent: 'Messaggio inviato con successo',
      messageError: 'Invio messaggio fallito'
    },

    pagination: {
      page: 'Pagina',
      of: 'di',
      showing: 'Visualizzazione',
      entries: 'voci',
      first: 'Prima',
      last: 'Ultima',
      next: 'Avanti',
      previous: 'Indietro'
    }
  },

  // Russian
  ru: {
    nav: {
      home: 'ГЛАВНАЯ',
      aboutUs: 'О НАС',
      immigrationServices: 'ИММИГРАЦИОННЫЕ УСЛУГИ',
      eServices: 'ЭЛЕКТРОННЫЕ УСЛУГИ',
      serviceFee: 'ПЛАТА ЗА УСЛУГИ',
      publicNotice: 'ПУБЛИЧНОЕ УВЕДОМЛЕНИЕ',
      eLibrary: 'ЭЛЕКТРОННАЯ БИБЛИОТЕКА',
      contactUs: 'СВЯЗАТЬСЯ С НАМИ'
    },

    quickMenu: {
      label: 'Быстрое меню:',
      hotNews: 'Горячие новости',
      visaGuidelines: 'Рекомендации по ВИЗЕ',
      faqs: 'Часто задаваемые вопросы'
    },

    home: {
      welcomeTitle: 'Добро пожаловать в иммиграционные службы Танзании',
      getStarted: 'НАЧАТЬ',
      getServiceInfo: 'Информация об услугах',
      servicesTitle: 'Онлайн-порталы электронной иммиграции Танзании',
      hotNewsTitle: 'Горячие новости',
      viewAll: 'Посмотреть все',
      noSlidesTitle: 'Нет доступных слайдов',
      noSlidesMessage: 'В настоящее время нет опубликованных слайдов для отображения. Пожалуйста, проверьте позже.',
      whoAreWeTitle: 'Кто мы',
      readMore: 'Читать далее',
      commissionerGeneral: 'Генеральный комиссар по иммиграции (CGI)',
      backHome: 'Вернуться на главную',
      viewOurServices: 'Посмотреть наши услуги',
      otherInformation: 'Другая информация'
    },

    services: {
      title: 'Наши услуги',
      applyNow: 'Подать заявку сейчас',
      learnMore: 'Узнать больше',
      ourServices: 'Наши услуги',
      serviceFees: 'Плата за услуги'
    },

    eServices: {
      title: 'Услуги электронной иммиграции',
      subtitle: 'Доступ к нашим онлайн-иммиграционным услугам',
      description: 'Подайте заявку на различные иммиграционные услуги онлайн через наши защищенные порталы'
    },

    aboutUs: {
      title: 'О нас',
      missionVision: 'Миссия и видение',
      mission: 'Миссия',
      vision: 'Видение',
      motto: 'Девиз',
      coreValues: 'Основные ценности',
      functions: 'Функции',
      organizationStructure: 'Организационная структура'
    },

    contactUs: {
      title: 'Связаться с нами',
      getInTouch: 'Свяжитесь с нами',
      sendMessage: 'Отправить сообщение',
      haveQuestion: 'Есть вопрос?',
      hereToHelp: 'Мы здесь, чтобы помочь! Нажмите кнопку ниже, чтобы отправить нам сообщение',
      sendUsMessage: 'Отправьте нам сообщение',
      workingHours: 'Часы работы',
      mondayFriday: 'Понедельник - Пятница: 8:00 - 16:00',
      mondayFridayShort: 'Понедельник - Пятница',
      workingHoursTime: '08:00 - 15:30',
      eat: 'EAT',
      name: 'Имя',
      email: 'Электронная почта',
      subject: 'Тема',
      message: 'Сообщение',
      submit: 'Отправить',
      officeHours: 'Часы работы',
      saturday: 'Суббота: Закрыто',
      sunday: 'Воскресенье: Закрыто'
    },

    common: {
      loading: 'Загрузка...',
      error: 'Ошибка',
      success: 'Успех',
      close: 'Закрыть',
      cancel: 'Отмена',
      save: 'Сохранить',
      delete: 'Удалить',
      edit: 'Редактировать',
      search: 'Поиск',
      filter: 'Фильтр',
      next: 'Далее',
      previous: 'Назад'
    },

    footer: {
      dodoma: 'ОФИС ДОДОМА',
      zanzibar: 'ОФИС ЗАНЗИБАР',
      importantLinks: 'ВАЖНЫЕ ССЫЛКИ',
      copyright: 'Авторское право © 2026 Департамент иммиграции Танзании. Все права защищены. Разработано разработчиками ИКТ иммиграции.'
    },

    publicNotice: {
      title: 'Публичное Уведомление',
      hotNews: 'Горячие Новости',
      dailyNews: 'Ежедневные Новости',
      announcements: 'Объявления',
      recentNews: 'Последние Новости',
      videos: 'Видео',
      gallery: 'Галерея',
      download: 'Скачать',
      viewMore: 'Показать Больше',
      prev: 'Предыдущая',
      next: 'Следующая',
      noNews: 'Новости недоступны',
      noAnnouncements: 'Объявления недоступны',
      noVideos: 'Видео недоступны',
      watchVideo: 'Смотреть Видео',
      closeVideo: 'Закрыть Видео'
    },

    downloads: {
      title: 'Загрузки',
      searchPlaceholder: 'Поиск документов...',
      sortBy: 'Сортировать По',
      newest: 'Новейшие',
      oldest: 'Старейшие',
      nameAZ: 'Имя А-Я',
      nameZA: 'Имя Я-А',
      download: 'Скачать',
      noDocuments: 'Документы не найдены',
      fileSize: 'Размер Файла',
      uploadDate: 'Дата Загрузки'
    },

    eLibrary: {
      title: 'Электронная Библиотека',
      searchPlaceholder: 'Поиск в библиотеке...',
      categories: 'Категории',
      allCategories: 'Все Категории',
      documents: 'Документы',
      publications: 'Публикации',
      reports: 'Отчеты',
      guidelines: 'Руководства',
      noResults: 'Результаты не найдены'
    },

    immigrationServices: {
      title: 'Иммиграционные Услуги',
      permits: 'Разрешения',
      visas: 'Визы',
      citizenship: 'Гражданство',
      passport: 'Паспорт',
      travelDocument: 'Проездной Документ',
      requirements: 'Требования',
      howToApply: 'Как Подать Заявку',
      processingTime: 'Время Обработки',
      fees: 'Сборы',
      applyOnline: 'Подать Заявку Онлайн',
      downloadForm: 'Скачать Форму'
    },

    serviceFee: {
      title: 'Плата за Услуги',
      serviceType: 'Тип Услуги',
      fee: 'Плата',
      currency: 'Валюта',
      processingTime: 'Время Обработки',
      notes: 'Примечания',
      searchFees: 'Поиск сборов...',
      allServices: 'Все Услуги'
    },

    faq: {
      title: 'Часто Задаваемые Вопросы',
      searchPlaceholder: 'Поиск вопросов...',
      noResults: 'Вопросы не найдены',
      categories: 'Категории',
      allQuestions: 'Все Вопросы'
    },

    forms: {
      firstName: 'Имя',
      lastName: 'Фамилия',
      email: 'Адрес Электронной Почты',
      phone: 'Номер Телефона',
      message: 'Ваше Сообщение',
      submit: 'Отправить',
      sending: 'Отправка...',
      required: 'Обязательно',
      invalidEmail: 'Неверный адрес электронной почты',
      messageSent: 'Сообщение успешно отправлено',
      messageError: 'Не удалось отправить сообщение'
    },

    pagination: {
      page: 'Страница',
      of: 'из',
      showing: 'Показано',
      entries: 'записей',
      first: 'Первая',
      last: 'Последняя',
      next: 'Далее',
      previous: 'Назад'
    }
  }
};

export default translations;

